'use strict';

Object.defineProperty(exports, '__esModule', {
  value: true
});
var _extends = require('@babel/runtime/helpers/extends');
var _defineProperty = require('@babel/runtime/helpers/defineProperty');
var _objectWithoutProperties = require('@babel/runtime/helpers/objectWithoutProperties');
var react = require('@chakra-ui/react');
var React = require('react');
var utils = require('@chakra-ui/utils');
function _interopDefaultLegacy(e) {
  return e && typeof e === 'object' && 'default' in e ? e : {
    'default': e
  };
}
var _extends__default = /*#__PURE__*/_interopDefaultLegacy(_extends);
var _defineProperty__default = /*#__PURE__*/_interopDefaultLegacy(_defineProperty);
var _objectWithoutProperties__default = /*#__PURE__*/_interopDefaultLegacy(_objectWithoutProperties);
var React__default = /*#__PURE__*/_interopDefaultLegacy(React);
var _excluded = ["isCurrentStep", "isLastCurrentStep"];
function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);
  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    enumerableOnly && (symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    })), keys.push.apply(keys, symbols);
  }
  return keys;
}
function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = null != arguments[i] ? arguments[i] : {};
    i % 2 ? ownKeys(Object(source), !0).forEach(function (key) {
      _defineProperty__default["default"](target, key, source[key]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) {
      Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
  }
  return target;
}
var StepIndicatorLine = function StepIndicatorLine(props) {
  var styles = react.useStyles();
  var isCurrentStep = props.isCurrentStep,
    isLastCurrentStep = props.isLastCurrentStep,
    rest = _objectWithoutProperties__default["default"](props, _excluded);
  var lineStyles = _objectSpread({
    top: '50%',
    transform: 'translateY(-50%) translateX(-1px)',
    position: 'absolute'
  }, styles.line);
  return /*#__PURE__*/React__default["default"].createElement(react.chakra.div, _extends__default["default"]({
    className: "chakra-step-indicator-line",
    "data-current": utils.dataAttr(isCurrentStep),
    "data-last": utils.dataAttr(isLastCurrentStep),
    __css: lineStyles
  }, rest));
};
StepIndicatorLine.displayName = 'StepIndicatorLine';
exports.StepIndicatorLine = StepIndicatorLine;